import React, { useMemo } from 'react';

import { Box } from '@mui/system';
import { Combobox } from '@bestdoctor/spectrum-uikit/Combobox';
import type { ComboboxOption } from '@bestdoctor/spectrum-uikit/Combobox';

import { Company, DataPeriod, IFiltersProps } from 'interfaces/global/globalInterfaces';
import { mainFiltersContainerStyle, mainFiltersSectionStyle, mainFiltersWrapperStyle } from 'ui/patients/mainFilters';

export const DocumentsFilters: React.FC<IFiltersProps> = ({
  dataPeriods,
  allCompanies,
  selectedCompanyByDocuments,
  handleSelectedCompanyByDocuments,
  selectedPeriodByDocuments,
  handleSelectedPeriodByDocuments,
}) => {
  // Преобразуем компании в формат ComboboxOption
  const companyOptions: ComboboxOption<Company>[] = useMemo(
    () =>
      (allCompanies || []).map((company) => ({
        label: company.title,
        value: company,
      })),
    [allCompanies]
  );

  // Преобразуем периоды в формат ComboboxOption
  const periodOptions: ComboboxOption<DataPeriod>[] = useMemo(
    () =>
      (dataPeriods || []).map((period) => ({
        label: period.title,
        value: period,
      })),
    [dataPeriods]
  );

  // Находим текущую выбранную опцию компании
  const selectedCompanyOption = useMemo(
    () => companyOptions.find((option) => option.value.uuid === selectedCompanyByDocuments?.uuid) || null,
    [companyOptions, selectedCompanyByDocuments]
  );

  // Находим текущую выбранную опцию периода
  const selectedPeriodOption = useMemo(
    () => periodOptions.find((option) => option.value.uuid === selectedPeriodByDocuments?.uuid) || null,
    [periodOptions, selectedPeriodByDocuments]
  );

  return (
    <Box component="section" sx={mainFiltersSectionStyle}>
      <Box sx={mainFiltersWrapperStyle}>
        <Box sx={mainFiltersContainerStyle}>
          <Combobox<Company>
            label="Компания"
            placeholder="Компания"
            options={companyOptions}
            value={selectedCompanyOption?.value}
            searchable
            clearable
            onChange={(value, option) => {
              if (value && option) {
                sessionStorage.setItem('mainFilterCompanyDocuments', JSON.stringify(value));
                sessionStorage.setItem('mainFilterPeriodDocuments', JSON.stringify(''));
                handleSelectedCompanyByDocuments(value);
              } else {
                sessionStorage.setItem('mainFilterCompanyDocuments', JSON.stringify(''));
                sessionStorage.setItem('mainFilterPeriodDocuments', JSON.stringify(''));
                handleSelectedCompanyByDocuments(null);
              }
            }}
            size='m'
          />
        </Box>

        <Box sx={{ width: '100%' }}>
          <Combobox<DataPeriod>
            label="Период данных"
            placeholder="Период данных"
            options={periodOptions}
            value={selectedPeriodOption?.value}
            searchable
            clearable
            onChange={(value, option) => {
              if (value && option) {
                sessionStorage.setItem('mainFilterPeriodDocuments', JSON.stringify(value));
                handleSelectedPeriodByDocuments(value);
              } else {
                sessionStorage.setItem('mainFilterPeriodDocuments', JSON.stringify(''));
                handleSelectedPeriodByDocuments(null);
              }
            }}
            size='m'
          />
        </Box>
      </Box>
    </Box>
  );
};
